import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

const PageTitle = () => {

    return (
        <div class="page-header mt-5 mb-5">

            <div class="row align-items-center">

                {/* Page title & subtitle  */}

                <div class="col-sm mb-1">
                    <p class="h2">Composer</p>
                    <p class="page-header-text">Configure JSON-RPC requests.</p>
                </div>

                {/* Gitbook API docs */}

                <div class="col-sm-auto">
                    <a class="btn btn-sm btn-primary" href="https://docs.web3api.com/" target="_blank" rel="noopener noreferrer">
                        <span class="mr-2">API Documentation</span>
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                </div>

            </div>
        </div>
    );
}

export { PageTitle };